export default {
  data() {
    return {
      inputType: 'radios',
      inputTypeDef: {}
    }
  }
}
